import React from 'react';

import './StickyNewYearFooter.css';

const StickyNewYearFooter: React.FC = () => {
  return <div className="sticky-new-year-footer"></div>;
};

export default StickyNewYearFooter;
